import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=22c12d0b&"
import script from "./TermsAndCondition.vue?vue&type=script&lang=js&"
export * from "./TermsAndCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c12d0b')) {
      api.createRecord('22c12d0b', component.options)
    } else {
      api.reload('22c12d0b', component.options)
    }
    module.hot.accept("./TermsAndCondition.vue?vue&type=template&id=22c12d0b&", function () {
      api.rerender('22c12d0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/components/TermsAndCondition.vue"
export default component.exports